/**
 * Bid Cell Renderer
 *
 * Generates HTML for bid display in table rows
 */

import type { Lot, State } from '../../types';
import { formatCurrencyDisplay, escapeHtml, escapeAttr } from '../formatting';
import styles from './tableCells.module.css';

export function buildBidCell(lot: Lot, state: State, isDeleted: boolean): string {
  const l = lot;

  let currentBid = '-';
  if (l.currentBid != null) {
    const amount = Number(l.currentBid);
    const formattedCurrentBid = formatCurrencyDisplay(amount);
    currentBid = formattedCurrentBid != null ? formattedCurrentBid : '$' + String(l.currentBid);
  } else if (l.currentBidRaw != null) {
    currentBid = escapeHtml(String(l.currentBidRaw));
  }

  let nextBid = '-';
  if (l.nextRequiredBid != null) {
    const nextAmount = Number(l.nextRequiredBid);
    const formattedNextBid = formatCurrencyDisplay(nextAmount);
    nextBid = formattedNextBid != null ? formattedNextBid : '$' + String(l.nextRequiredBid);
  } else if (l.nextRequiredBidRaw != null) {
    nextBid = escapeHtml(String(l.nextRequiredBidRaw));
  }

  const bidCombined =
    '<div class="' +
    styles.bidLines +
    '">' +
    '<div class="' +
    styles.bidLine +
    '">Current: ' +
    currentBid +
    '</div>' +
    '<div class="' +
    styles.bidLine +
    '">Next: ' +
    nextBid +
    '</div>' +
    '</div>';

  let bidHtml = bidCombined;
  const bidPending = state.pendingBidRefreshIds && l.id && state.pendingBidRefreshIds.has(l.id);
  if (state.mode === 'auth0' && l.remote && l.id && !isDeleted) {
    bidHtml =
      '<button class="' +
      styles.bidRefresh +
      '" data-action="refresh-bid" data-id="' +
      escapeAttr(l.id) +
      '"' +
      (bidPending ? ' disabled' : '') +
      ' title="Refresh current bid">' +
      bidCombined +
      '</button>';
  }

  return bidHtml;
}
